import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { map, take } from 'rxjs/operators';

import { AnimalCountCard } from '../models/flock.model';
import { FlockService } from '../services/flock.service';

@Injectable()
export class AnimalCountCardsResolver {
  constructor(private flockService: FlockService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.flockService.loadAnimalCountCards(Number(route.paramMap.get('id'))).pipe(
      take(1),
      map((cards: AnimalCountCard[]) => cards),
    );
  }
}
